import {v4 as uuidv4} from 'uuid';

class Sponsor {
    constructor(data) {
        this.id = data.id || uuidv4();
        this.title = data.title || '';
        this.short_description = data.short_description || '';
        this.button_title = data.button_title || '';
        this.button_url = data.button_url || '';
        this.button_color = data.button_color || '';
        this.approval_number = data.approval_number || '';
        this.avatar = data.avatar || {
            url: '',
            key: ''
        };
    }
}

export default Sponsor;